import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CommonUtil } from '../../../../shared/services/utility/common.service';
import { UserService } from '../../../../auth/user.service';
import { SiteDashboardService } from '../../site-dashboard.service';
import { PlinksDashboardService } from '../plinks-dashboard/plinks-dashboard.service';
import { DevicesDashboardService } from '../../devices/devices-dashboard.service';
import * as _ from 'underscore';

@Component({
	selector: 'app-plinks-listing',
	templateUrl: './plinks-listing.component.html',
	styleUrls: ['./plinks-listing.component.css']
})
export class PlinksListingComponent implements OnInit, OnDestroy, OnChanges {

	@Input() currentSite: any = {};
	@Input() siteId: number;
	@Input() customerId: number;
	@Input() currentUser: any = {};

	plinksListing: any = {};
	timeoutId;
	hasPlinks: boolean = true;
	connectivityStatusList = [];
	productionIps: any[];
	checkedDevices = [];
	isLoading: boolean = false;
	wifiIcon       = '../../../../../assets/images/icon-wifi-svg.svg';
	noWifiIcon     = '../../../../../assets/images/icon-no-wifi-svg.svg';
	cellularIcon   = '../../../../../assets/images/icon-cellular-svg.svg';
	noCellularIcon = '../../../../../assets/images/icon-no-cellular-svg.svg'
	whiteCircle    = '../../../../../assets/images/icon-white-circle.svg'

	@Output() plinksListingReady = new EventEmitter<object>();
	@Output() siteTagsChanged = new EventEmitter<object>();
	@Output() deviceTagsChanged = new EventEmitter<object>();
	@Output() refreshFilter = new EventEmitter();
	@Output() deviceIsChecked = new EventEmitter<any>();

	constructor(
		private commonUtil: CommonUtil,
		public userService: UserService,
		private siteDashboard: SiteDashboardService,
		private plinksDashboard: PlinksDashboardService,
		private deviceDashboard: DevicesDashboardService
	) { }

	ngOnInit() {
		this.getPlinksListing();
	}

	ngOnDestroy() {
		if(this.timeoutId)
			clearTimeout(this.timeoutId);
		this.isLoading = false;
	}

	ngOnChanges(changes) {
		// Only call getPlinksListing if siteId or customerId actually changed
		if (changes.siteId || changes.customerId) {
			// Check if the values are actually different and not undefined/null
			const siteIdChanged = changes.siteId &&
				changes.siteId.currentValue !== changes.siteId.previousValue &&
				changes.siteId.currentValue;
			const customerIdChanged = changes.customerId &&
				changes.customerId.currentValue !== changes.customerId.previousValue &&
				changes.customerId.currentValue;

			if (siteIdChanged || customerIdChanged) {
				this.getPlinksListing();
			}
		}
	}

	getPlinksListing(isRefresh = false) {
		if(this.timeoutId)
			clearTimeout(this.timeoutId);

		// Prevent multiple simultaneous calls
		if(this.isLoading && !isRefresh) {
			return;
		}

		let siteid = this.siteId;
		let customerid = this.customerId;

		if(siteid && customerid) {
			this.isLoading = true;
			this.plinksDashboard.getPlinksListing(customerid, siteid, isRefresh, {}).subscribe((response: any) => {
				this.hasPlinks = (Array.isArray(response.list) && response.list.length > 0);

				if(!this.hasPlinks) {
					this.plinksListingReady.emit({
						'list': {},
						'hasDevices': false,
						'connectivityStatusList': []
					});
					this.isLoading = false;
					return;
				}

				var plinksListing = {'PolarLink': []};
				var result = _.sortBy(response.list, 'serialnumber');
				var deviceGroups = {};

				result.forEach((plink) => {
					plink.selected = false;
					plink.isShow = true;
					plink.tags = [];
					plink.groups = [];
					plink.prettyName = plink.serialnumber;

					// Add connectivity status and image class
					if(plink.actviewenabled) {
						plink.connectivityStatus = this.deviceStatus(plink.lastconnecttime);
						plink.imageClass = plink.connectivityStatus == 'Offline' ? 'pl-disconnected' : 'pl-connected';
					} else {
						plink.connectivityStatus = 'Disabled';
						plink.imageClass = 'pl-disabled';
					}

					if(plink?.data && (plink?.data.polarlinkconnectiontype !== null && plink?.data.polarlinkconnectiontype !== undefined) ){
						const connection = plink.data.polarlinkconnectiontype;
						const status = this.deviceStatus(plink.lastconnecttime);

						if(connection == 0)
							plink.connectionType = (status == 'Offline') ? this.noWifiIcon : this.wifiIcon;
						else
							plink.connectionType = (status == 'Offline') ? this.noCellularIcon : this.cellularIcon;
						
					}else{
						plink.connectionType = this.whiteCircle;
					}

					plinksListing['PolarLink'].push(plink);
				});

				// Handle tags if available
				if(response.tags) {
					let siteTagsById = response.tags.siteTags || {};
					let deviceTags = response.tags.deviceTags || {};

					// Convert siteTags object to array format expected by devices-listing
					let siteTags = [];
					for (var tagIndex in siteTagsById) {
						var item = siteTagsById[tagIndex];
						item.isActive = false;
						siteTags.push(item);
					}

					let siteGroups = response.groups || {};
					this.siteTagsChanged.emit([siteTags, siteGroups]);

					// Process device tags - similar to chargers-listing logic
					result.forEach((plink) => {
						var tags = deviceTags[plink.id] || [];
						plink.tags = [];
						for (var i = 0; i < tags.length; i++) {
							if (siteTagsById[tags[i].tagid]) {
								let tmpTag = Object.assign({}, tags[i]);
								plink.tags.push(Object.assign(tmpTag, siteTagsById[tags[i].tagid]));
							}
						}
					});

					this.deviceTagsChanged.emit([deviceTags, deviceGroups]);
				} else {
					// If no tags available, emit empty arrays to prevent undefined errors
					this.siteTagsChanged.emit([[], {}]);
					this.deviceTagsChanged.emit([{}, {}]);
				}

				this.plinksListing = plinksListing;
				this.connectivityStatusList = [
					{label: 'All', value: 'all'},
					{label: 'Connected', value: 'Connected'},
					{label: 'Disconnected', value: 'Disconnected'},
					{label: 'Disabled', value: 'Disabled'}
				];



				this.plinksListingReady.emit({
					'list': this.plinksListing,
					'hasDevices': this.hasPlinks,
					'connectivityStatusList': this.connectivityStatusList
				});

				this.isLoading = false;

				if(!isRefresh) {
					this.timeoutId = setTimeout(() => {
						this.getPlinksListing(true);
					}, 30000);
				}
			}, (error) => {
				console.error('Error loading plinks:', error);
				this.isLoading = false;
			});
		} else {
			this.isLoading = false;
		}
	}

	deviceStatus = (connectTime: string) => {
		const lastConnectTime = new Date(connectTime).getTime();
		const now = Date.now();
		let difference = (now - lastConnectTime) / 1000 / 60 / 60;

		if(difference > 24) // Greater than 24 hours
			return 'Offline'
		else if(difference < 6) // Less than 6 hours
			return 'Updated';
		else if(difference <= 24) // Less than or Equal 24 hours
			return 'Active';
	}

	setListingObject(plinksListing) {
		this.plinksListing = plinksListing;
	}

	deviceChecked(device, isChecked) {
		device.selected = isChecked;
		this.deviceIsChecked.emit(isChecked);
	}

	selectAllDevices(isChecked) {
		for(let modelType in this.plinksListing) {
			this.plinksListing[modelType].forEach(plink => {
				if(plink.isShow) {
					plink.selected = isChecked;
				}
			});
		}

		let checkedCount = 0;
		if(isChecked) {
			for(let modelType in this.plinksListing) {
				checkedCount += this.plinksListing[modelType].filter(p => p.isShow).length;
			}
		} else {
			checkedCount = -this.getVisibleDevicesCount();
		}

		this.deviceIsChecked.emit({checkedCount: checkedCount});
	}

	getVisibleDevicesCount() {
		let count = 0;
		for(let modelType in this.plinksListing) {
			count += this.plinksListing[modelType].filter(p => p.isShow).length;
		}
		return count;
	}

	restartPolarlinkDevice(plinkId: any){
		this.deviceDashboard.restartDevice('plink', plinkId, {}).subscribe();
	}
}
